import { Platform } from "@dndbeyond/event-pipeline-lib/shared";

export const getPlatform = () => {
  const queryParams = new URLSearchParams(
    globalThis.window?.location.search ?? "",
  );

  return (queryParams?.get("platform") ?? Platform.Web) as Platform;
};
